import { render, staticRenderFns } from "./risefansdetail.vue?vue&type=template&id=422cd342&scoped=true"
import script from "./risefansdetail.vue?vue&type=script&lang=js"
export * from "./risefansdetail.vue?vue&type=script&lang=js"
import style0 from "./risefansdetail.vue?vue&type=style&index=0&id=422cd342&prod&lang=less&scoped=true"
import style1 from "./risefansdetail.vue?vue&type=style&index=1&id=422cd342&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422cd342",
  null
  
)

export default component.exports